import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { UserHeader } from "../components/UserHeader";
import { SinglePie } from "../components/SinglePie";
import { AllCakes } from "../components/AllCakes";
import { baseURL } from "../services/axios";


const GeneralSummaryPage = () => {
const { id } = useParams<{ id: string }>();
const childCode = id ? Number(id) : null;  const [childId, setChildId] = useState<number | null>(null);
  const [summary, setSummary] = useState<any>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  // שליפת ה-id האמיתי של הילד מהשרת לפי code
  // useEffect(() => {
  //   if (!id) return;
  //   const fetchChild = async () => {
  //     try {
  //       const response = await fetch(`${baseURL}/child/${id}`, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       });
  //       if (!response.ok) return;
  //       const data = await response.json();
  //       setChildId(data.id); // כאן זה ה-id (string)
  //     } catch {}
  //   };
  //   fetchChild();
  // }, [id]);

useEffect(() => {
  console.log("Received code from URL:", childCode);
  if (!childCode || isNaN(childCode)) return;

  const fetchSummary = async () => {
    try {
      const response = await fetch(
        `${baseURL}/calculatePercentages/AnalyzeAllSessions?childId=${childCode}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        const text = await response.text();
        setError(text);
        return;
      }

      const data = await response.json();
      setSummary(data);
    } catch {
      setError("שגיאה בטעינת הסיכום הכללי");
    } finally {
      setLoading(false);
    }
  };

  fetchSummary();
}, [childCode]);

  // פונקציה להמרת נתונים לגרף
  const convertToChartData = (dataObj: { [key: string]: number }) => {
    return Object.entries(dataObj).map(([name, value]) => ({ name, value }));
  };

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      {/* <UserHeader /> */}
      <h1>סיכום כללי</h1>
      {loading && <p>טוען נתונים...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {summary && summary.global && (
        <>
          <h2>סיכום גלובלי</h2>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "2rem",
              flexWrap: "wrap",
            }}
          >
            <SinglePie
              title="🟢 התנהגות"
              data={convertToChartData(summary.global.behaviors || {})}
              colors={["#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7"]}
            />
            <SinglePie
              title="🟡 נסיבות"
              data={convertToChartData(summary.global.path || {})}
              colors={["#DDA0DD", "#98D8C8", "#F7DC6F", "#BB8FCE", "#85C1E9"]}
            />
            <SinglePie
              title="🔴 תוצאות"
              data={convertToChartData(summary.global.response || {})}
              colors={["#FF8A65", "#81C784", "#64B5F6", "#FFB74D", "#A1887F"]}
            />
          </div>
        </>
      )}
      <h2 style={{ marginTop: "2rem" }}>סיכום לפי סשן</h2>
      {summary &&
        summary.perSession &&
        Object.entries(summary.perSession).map(([sessionId, cakes]: any) => (
          <div key={sessionId} style={{ marginBottom: "2rem" }}>
            <AllCakes childName={""} sessionId={sessionId} />
          </div>
        ))}
    </div>
  );
};

export default GeneralSummaryPage;
